var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.04 0C31.4 0 40 9.31397 40 19.97C40 32.3285 29.92 40 20 40C16.72 40 13.08 39.1187 10.16 37.3961C9.14 36.7752 8.28 36.3145 7.18 36.675L3.14 37.8768C2.12 38.1973 1.2 37.3961 1.5 36.3145L2.84 31.8277C3.06 31.2068 3.02 30.5458 2.7 30.025C0.98 26.8603 0 23.3951 0 20.03C0 9.49424 8.42 0 20.04 0ZM29.18 17.4862C27.76 17.4862 26.62 18.6279 26.62 20.0501C26.62 21.4522 27.76 22.6139 29.18 22.6139C30.6 22.6139 31.74 21.4522 31.74 20.0501C31.74 18.6279 30.6 17.4862 29.18 17.4862ZM19.96 17.4862C18.56 17.4662 17.4 18.6279 17.4 20.03C17.4 21.4522 18.54 22.5939 19.96 22.6139C21.38 22.6139 22.52 21.4522 22.52 20.0501C22.52 18.6279 21.38 17.4862 19.96 17.4862ZM10.74 17.4862C9.32 17.4862 8.18 18.6279 8.18 20.0501C8.18 21.4522 9.34 22.6139 10.74 22.6139C12.16 22.5939 13.3 21.4522 13.3 20.0501C13.3 18.6279 12.16 17.4862 10.74 17.4862Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.adc92b5d.svg";
export { ForwardRef as ReactComponent };